import { Controller } from '@hotwired/stimulus';

export default class PartnerListingOrderSelectController extends Controller {
  static values = {
    routeMap: Object,
    activeId: Number,
  };

  connect() {
    this.element.addEventListener('click', this.onOptionClickCapture, true);
  }

  disconnect() {
    this.element.removeEventListener('click', this.onOptionClickCapture, true);
  }

  onOptionClickCapture = (event) => {
    const option = event.target;
    if (Number(option.value) === this.activeIdValue) {
      event.stopPropagation();
    }
  };

  onChange(event) {
    const selected = event.detail?.value?.[0];
    if (!selected) {
      return;
    }

    const url = this.routeMapValue[selected.id];
    if (url) {
      window.location = url;
    }
  }
}
